<template>
  <div class="main-container">
    <breadcrumb :list="breadcrumbList" />
    <tl-header type="h1">
      <div class="main-header">Statutory Bonus</div>
    </tl-header>
    <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission">
      You have only view permission.
    </div>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <div class="twoColumnGrid">
      <div class="info">
        <p>
          All companies in operation for more than 5 yrs having 20 or more employees are mandated by the Govt. of India to
          pay Statutory Bonus to their employees having Basic+DA &lt; Rs. 21,000.
        </p>
      </div>
    </div>
    <br />
    <div class="singleColumnGrid">
      <label for>Incorporation Date</label>
      <!-- <p>{{incorporationDate.incorporationDate}}</p> -->
      <p>{{getFormattedDate(incorporationDate.incorporationDate)}}</p>
    </div>
    <br />
    <div class="singleColumnGrid" :disabled="!ifTeamleaderAnchorPermission">
      <span class="calciLabel">Statutory Bonus Calculation</span>
      <span>
        <input
          type="number"
          class="bonusPercentageInput"
          name="bonusPercentage"
          data-vv-as="percentage value"
          v-model="statutoryBonusData.bonusPercentage"
          v-validate="{ required: true, numeric: true }"
          :class="{ 'is-invalid': submitted && errors.has('bonusPercentage') }"
        />
        <label for>% of Salary i.e. Basic + DA (8.33% to 20%)</label>
      </span>
      <div
        v-if="submitted && errors.has('bonusPercentage')"
        class="is-danger"
      >{{ errors.first("bonusPercentage") }}</div>
      <p>
        Note: statutory bonus is calculated on Max{Min [(Basic + DA) or INR 7000] or Minimum Wages of the state in which employee
        falss}
      </p>
    </div>
    <br />
    <div class="label">Payment Frequency</div>
    <div class="row" :disabled="!ifTeamleaderAnchorPermission">
      <div class="col-4">
        <tl-radio
          label="Monthly"
          name="paymentFrequency"
          id="monthly"
          value="monthly"
          v-model="statutoryBonusData.paymentFrequency"
        />
      </div>
      <div class="col-4">
        <tl-radio
          label="Annually"
          name="paymentFrequency"
          id="annually"
          value="annually"
          v-model="statutoryBonusData.paymentFrequency"
        />
      </div>
      <div class="col-12 margintop-20">
        <div class="label-text">Effective Date</div>
        <date-picker
          @datevalue="(val)=>statutoryBonusData.selectedDate=val"
          :value="statutoryBonusData.selectedDate"
        />
        <!-- <date-picker v-if="statutoryBonusData.paymentFrequency == 'monthly'" class="custom-width" @datevalue="(val)=>statutoryBonusData.selectedDate=val"
          :value="statutoryBonusData.selectedDate" name="selectedDate" data-vv-as="date" v-validate="{ required: true}" :minimum-view="'month'"
        :formatDate="format" :class="{ 'is-invalid': submitted && errors.has('selectedDate') }" />-->
        <div
          v-if="submitted && errors.has('selectedDate')"
          class="is-danger"
        >{{ errors.first("selectedDate") }}</div>
      </div>
    </div>
    <bottom-action-container class="placeEnd">
      <template slot="end">
        <btn-grp>
          <btn text="Cancel" type="secondary" @click="cancel" />
          <btn text="Save" type="primary" @click="saveStatutoryBonus"  :disabled="!ifTeamleaderAnchorPermission"/>
        </btn-grp>
      </template>
    </bottom-action-container>

    <pop-up-message
      v-if="showSuccessMsg"
      message="Statutory Bonus has been successfully added."
      btnText="Ok"
      @back="back"
    ></pop-up-message>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      showSuccessMsg: false,
      toast: false,
      errmsg: "",
      breadcrumbList: [
        {
          name: "Payroll",
          url: `/dashboard/${this.$route.params.entity_index}/payroll`
        },
        {
          name: "Utilities",
          url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities`
        },
        {
          name: "Statutory Bonus",
          url: ""
        }
      ],
      format: "MMMM",
      statutoryBonusData: {
        bonusPercentage: "",
        selectedDate: "",
        paymentFrequency: "monthly"
      },
      submitted: false,
      incorporationDate: "",
      statutoryBonusValue: false,
      role: ""
    };
  },

  activated() {
    this.refresh();
    this.setIncorporationDate();
    this.getOrgLeIdList();
  },

  computed: {
    ...mapState({
      legalEntities: state => state.onboard.legal_entities.data
    }),
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID"
    }),
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      } else {
        return this.getLegalEntityId(0);
      }
    },
    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),
    ifTeamleaderAnchorPermission() {
        if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
          if(this.statutoryBonusValue) {
            return true;
          } else {
            return false;
          }
        } 
        // else {
        // return true 
        // }
    }
  },
  methods: {
    ...mapActions({
      fetch_statutory_bonus:
        "dashboard/payroll/utilities/statutory_bonus/fetchAll",
      create_statutory_bonus:
        "dashboard/payroll/utilities/statutorybonus/create"
    }),
    refresh() {
      this.statutoryBonusData = {
        bonusPercentage: "",
        selectedDate: "",
        paymentFrequency: "monthly"
      };
    },
    getFormattedDate(event) {
      try {
        if (event) {
          return (
            new Date(event).getDate() +
            " " +
            this.getMonthName(new Date(event).getMonth() + 1) +
            " " +
            new Date(event).getFullYear()
          );
        } else {
          return "";
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    getMonthName(monthId) {
      try {
        switch (monthId) {
          case 1:
            return "January";
            break;
          case 2:
            return "February";
            break;
          case 3:
            return "March";
            break;
          case 4:
            return "April";
            break;
          case 5:
            return "May";
            break;
          case 6:
            return "June";
            break;
          case 7:
            return "July";
            break;
          case 8:
            return "August";
            break;
          case 9:
            return "September";
            break;
          case 10:
            return "October";
            break;
          case 11:
            return "November";
            break;
          case 12:
            return "December";
            break;
          default:
            return "";
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    setIncorporationDate() {
      try {
        if (this.$route.params.entity_index) {
          this.incorporationDate = this.legalEntities[
            this.$route.params.entity_index
          ];
        } else {
          this.incorporationDate = this.legalEntities[0].incorporationDate
            ? this.legalEntities[0].incorporationDate
            : "";
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    saveStatutoryBonus() {
      try {
        this.submitted = true;
        this.$validator.validate().then(valid => {
          if (valid) {
            this.postData();
          }
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    async postData() {
      try {
        let obj = {
          data: {
            le_id: this.leId,
            statutory_bonus: [
              {
                from: this.statutoryBonusData.selectedDate,
                to: "",
                percentage: this.statutoryBonusData.bonusPercentage,
                frequency: this.statutoryBonusData.paymentFrequency
              }
            ]
          }
        };
        let res = await this.create_statutory_bonus(obj);
        if (res.status) {
          this.showSuccessMsg = true;
        }
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },

    cancel() {
      this.$router.go(-1);
    },

    back() {
      try {
        this.showSuccessMsg = false;
        this.$router.push({
          path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities`
        });
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },

   ...mapActions({
        getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    async getOrgLeIdList() {
        const org = this.orgId;
        const le = this.leId;
        //console.log("Org:",org);
        //console.log("Le ID",le);
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
            ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.statutoryBonusValue = data.data.user.permissions.statutory_bonus ? true : false;
        //console.log("PL-3406",data);
    }
  }
};
</script>

<style lang="scss" scoped>
.component-wrapper {
  margin-left: 14px;
  margin-top: 10px;
}

.main-header {
  color: #6d6d6d;
  margin-top: 37px;
  font-size: 16px;
}

.nav {
  color: #555555;
  font-size: 11px;
}

.filters {
  display: grid;
  grid-gap: 10px;
  grid-template: auto / repeat(6, minmax(100px, 1fr));
}

.info {
  background-color: #f9f9f9;
  padding: 10px 15px;
  p {
    font-size: 12px;
  }
}

.label {
  margin-bottom: 15px;
}

.calciLabel {
  font-size: 12px;
}

.bonusPercentageInput {
  border-radius: 4px;
  border: 1px solid #dadada;
  padding: 10px;
  margin-right: 10px;
  width: 100%;
  max-width: 5%;
  height: 35px;
  transition: ease-in-out, width 0.35s ease-in-out;

  &:focus {
    outline: none;
    border: 2px solid #34c0be;
  }
}

.is-danger {
  color: #f22435;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
